import kebabCase from 'lodash/kebabCase';

export function startCase(value: string) {
    return kebabCase(value)
        .split('-')
        .map((word = '') => `${word[0]?.toUpperCase()}${word.slice(1)}`)
        .join(' ');
}
